import { loadYmapsScript } from './ymapsLoader.js';

/*@ngInject*/
function yandexMapsService(urlHelper, $q, $translate) {
  const service = this;

  // дополнительная функция проверки признаков что янекс.карта уже как-то загружена
  service.isLoadedYandexMap = function () {
    return window.ymaps != null;
  };
  service.getIsLoadedMap = () => service.loadYandexMap();
  service.loadYandexMap = function (params) {
    const query = urlHelper.paramsToString(angular.extend({
      lang: 'ru-RU'
    }, params || {}));
    return $q.when(loadYmapsScript(`https://api-maps.yandex.ru/2.1/?${query}`));
  };
  service.getCoordsCityByName = cityName => ymaps.geocode(cityName, {
    results: 1
  }).then(res => {
    const firstGeoObject = res.geoObjects.get(0);
    if (firstGeoObject) {
      const bounds = firstGeoObject.properties.get('boundedBy');
      const coords = firstGeoObject.geometry.getCoordinates();
      return {
        bounds,
        coords
      };
    }
    return null;
  }).catch(err => {
    if (err.message === 'scriptError') {
      throw $translate.instant('Js.ShippingPointsList.ErrorApiKey');
    }
    throw 'Error loading map';
  });
  service.getLocation = () =>
  // result.geoObjects.position
  ymaps.geolocation.get({
    provider: 'yandex',
    mapStateAutoApply: true
  });
  service.getCityByCoords = (latitude, longitude) => ymaps.geocode([latitude, longitude]).then(res => {
    const firstGeoObject = res.geoObjects.get(0);
    return firstGeoObject.getLocalities()[0];
  });
  service.checkPointInPolygons = (coords, polygons = []) => {
    let isContain = polygons.length === 0;
    let currentPolygon;
    if (polygons.length > 0) {
      for (const polygon of polygons) {
        if (polygon?.geometry?.contains(coords)) {
          isContain = true;
          currentPolygon = polygon;
          break;
        }
      }
    }
    return {
      isContain,
      currentPolygon
    };
  };
}
yandexMapsService.$inject = ["urlHelper", "$q", "$translate"];
export default yandexMapsService;